import {getScale} from './scale';
import {stringValue} from 'vega-util';

export default function(enc, scope, params, fields) {
  return 'this.gradient('
    + getScale(enc.gradient, scope, params, fields)
    + ',' + stringValue(enc.start)
    + ',' + stringValue(enc.stop)
    + ',' + stringValue(enc.count)
    + ')';
}



//////////////////
// WEBPACK FOOTER
// ./~/vega-parser/src/parsers/encode/gradient.js
// module id = 1464
// module chunks = 0